(function(){
  var ZOOM_FROM=1, ZOOM_TO=1.25, ZOOM_MS=5000, FADE_MS=1000, FPS=60;
  document.addEventListener('DOMContentLoaded', function(){
    var slides = document.querySelectorAll('.hero-cinema__slide');
    if (!slides.length) return;
    if (slides.length === 1) { slides[0].style.opacity='1'; slides[0].style.transform='scale(1)'; return; }
    var current=0, step=(ZOOM_TO-ZOOM_FROM)/(ZOOM_MS/(1000/FPS)), scale=ZOOM_FROM, zoomTimer=null;
    slides[current].style.opacity='1';
    slides[current].style.transform='scale('+ZOOM_FROM+')';
    function startZoom(slide, onDone){
      scale=ZOOM_FROM; slide.style.transform='scale('+scale+')';
      zoomTimer=setInterval(function(){
        scale+=step;
        if (scale>=ZOOM_TO){ scale=ZOOM_TO; slide.style.transform='scale('+scale+')'; clearInterval(zoomTimer); zoomTimer=null; if(onDone) onDone(); return; }
        slide.style.transform='scale('+scale+')';
      }, 1000/FPS);
    }
    function preloadSlide(slide, cb){
      var m=/url\((['"]?)(.*?)\1\)/.exec(slide.style.backgroundImage||'');
      if (!m){ cb(); return; }
      var img=new Image();
      img.src=m[2];
      if (img.decode) img.decode().then(cb, cb);
      else if (img.complete) cb();
      else { img.onload=cb; img.onerror=cb; }
    }
    function switchTo(nextIndex){
      var curSlide=slides[current], nxtSlide=slides[nextIndex];
      preloadSlide(nxtSlide, function(){
        nxtSlide.style.transform='scale('+ZOOM_FROM+')'; nxtSlide.style.opacity='0';
        requestAnimationFrame(function(){
          curSlide.style.opacity='0'; nxtSlide.style.opacity='1';
          startZoom(nxtSlide, function(){ var ni=(current+1)%slides.length; switchTo(ni); });
        });
        current=nextIndex;
        setTimeout(function(){ curSlide.style.transform='scale('+ZOOM_FROM+')'; }, FADE_MS);
      });
    }
    startZoom(slides[current], function(){ var ni=(current+1)%slides.length; switchTo(ni); });
  });
})();